import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

import { bcorpDesc1, bcorpDesc2, bcorpTitle } from 'assets/content/prescription/content';
import bCorpLogo from 'assets/images/B-Corp-Logo-Black.png';
import climateneutralLogo from 'assets/images/ClimateNeutralCertified.png';

const BcorpPhilosophyContent = styled.div`
  background: ${theme.colors.neutral[200]};
  padding: 72px 50px;

  ${legacyTheme.breakpoints.up('md')} {
    padding: 144px 135px;
  }
`;

const ImageRow = styled('div')`
  display: flex;
  justify-content: center;

  img {
    height: 125px;
    display: inline-block;
    margin: 15px;
  }
`;

const BcorpPhilosophy = ({ className }) => (
  <BcorpPhilosophyContent className={className}>
    <Typography align="center" bold paragraph upperCase variant="mono2">
      {bcorpTitle}
    </Typography>
    <Typography align="center" variant="p2">
      {bcorpDesc1}
    </Typography>
    <Typography align="center" paragraph variant="p2">
      {bcorpDesc2}
    </Typography>
    <ImageRow>
      <img alt="B-Corp Logo" src={bCorpLogo.src} />
      <img alt="Climate neutral certified Logo" src={climateneutralLogo.src} />
    </ImageRow>
  </BcorpPhilosophyContent>
);

BcorpPhilosophy.propTypes = {
  className: PropTypes.string,
};

BcorpPhilosophy.defaultProps = {
  className: null,
};

export default BcorpPhilosophy;
